<template>
  <div id="app" :style="backgroundStyle">
    <router-view v-if="isAuthorized" />

    <AuthGate
      v-else
      :initialNombre="initialNombre"
      :initialPin="initialPin"
      @authorized="onAuthorized"
    />
  </div>
</template>

<script>
import AuthGate from '@/components/AuthGate.vue';
import { ACCESS_VALIDATION_ENABLED } from '@/config';
import { readAuth } from '@/utils/auth';
import { setSession } from '@/utils/session';

export default {
  name: 'App',
  components: { AuthGate },
  data() {
    return {
      isAuthorized: false,
      initialNombre: '',
      initialPin: '',
    };
  },
  computed: {
    backgroundStyle() {
      return {
        background: 'linear-gradient(to right, #48465c 0%, #211f2e 50%, #151d2b 100%)',
        minHeight: '100vh',
        width: '100%',
      };
    },
  },
  created() {
    // Si el toggle está apagado, entramos directo (modo offline)
    if (!ACCESS_VALIDATION_ENABLED) {
      this.isAuthorized = true;
      return;
    }

    const auth = readAuth();
    if (auth) {
      this.isAuthorized = true;
      this.initialNombre = auth.nombre || '';
      this.initialPin = auth.pin || '';
      // Prefill del nombre en la primera página (si el usuario luego lo edita, no pasa nada)
      setSession({ nombre: auth.nombre || '' });
    }
  },
  methods: {
    onAuthorized({ nombre }) {
      this.isAuthorized = true;
      if (nombre) setSession({ nombre });
    },
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
